// import React from 'react';
// import CountUp from 'react-countup';

// const FunfactSection = () => {
//   const funfacts = [
//     { end: 250, suffix: '+', text: 'Booking monthly' },
//     { end: 30, suffix: '+', text: 'Visitors daily' },
//     { end: 98, suffix: '%', text: 'Positive feedback' },
//     { end: 20, suffix: '+', text: 'Awards & honors' }
//   ];

//   return (
//     <section className="funfact-section light-bg mx-60">
//       <div className="auto-container">
//         <div className="row">
//           {funfacts.map((fact, index) => (
//             <div className="col-lg-3 funfact-block" key={index}>
//               <div className="count-outer count-box">
//                 <span className="count-text">
//                   <CountUp end={fact.end} duration={3} />
//                 </span>
//                 <span className="plus">{fact.suffix}</span>
//               </div>
//               <div className="text">{fact.text}</div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default FunfactSection;

import React from 'react';
import CountUp from 'react-countup';

const FunfactSection = () => {
  const funfacts = [
    { end: 25, suffix: '+', text: 'Happy Guests So Far' },
    { end: 5, suffix: '+', text: 'Nature-Inspired Villas' },
    { end: 15, suffix: '+', text: 'Activities & Experiences' },
    { end: 10, suffix: '+', text: 'Dedicated Team Members' }
  ];

  return (
    <section className="funfact-section light-bg mx-60">
      <div className="auto-container">
        <div className="row">
          {funfacts.map((fact, index) => (
            <div className="col-lg-3 funfact-block" key={index}>
              <div className="count-outer count-box">
                <span className="count-text">
                  <CountUp end={fact.end} duration={3} />
                </span>
                <span className="plus">{fact.suffix}</span>
              </div>
              <div className="text">{fact.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FunfactSection;
